/** @format */

import React from 'react'
import ReactDOM from 'react-dom'
import { CookiesProvider } from 'react-cookie'
import GA4React from 'ga-4-react'

import App from './App'
import { initSizeListener } from './utils'

import './index.css'
;(async () => {
  const ga4react = new GA4React('G-WX5P6DXJ64')
  await ga4react.initialize()

  require('./components/path-data-polyfill')
  require('./components/path-seg-polyfill')

  initSizeListener()

  ReactDOM.render(
    <CookiesProvider>
      <App />
    </CookiesProvider>,
    document.getElementById('root'),
  )
})()
